<template>
  <div class="card p-3 shadow">
    <h3
        class="mb-3"
        v-if="item"
        @click="questionnaireId = null">
      {{item.title}}
    </h3>

    <QuestionnaireItem
        v-if="item"
        :questionnaire="item"
        :comment-answer="commentAnswer" />
    <QuestionnaireList
        v-else
        :questionnaires="list"
        v-on:select-questionnaire="selectQuestionnaire"/>
  </div>
</template>

<script>
  import QuestionnaireItem from './questionnaire/Item';
  import QuestionnaireList from './questionnaire/List';

  export default {
    name: 'Questionnaire',

    components: {QuestionnaireList, QuestionnaireItem},

    props: ['questionnaires', 'answers', 'client'],

    data() {
      return {
        questionnaireId: null,
        questionnaireLoaded: false,
      };
    },

    computed: {
      item() {
        return this.list.find(
          questionnaire => this.questionnaireId === questionnaire.id
        );
      },

      list() {
        const answers = {};
        const questionnaires = [];

        this.answers.forEach(answer => {
          answers[answer.field] = answer;
        });

        for (const qs of this.questionnaires) {
          const questionnaire = {
            id: qs.id,
            title: qs.title,
            categories: [],
            totalCount: 0,
            answeredCount: 0,
          };

          for (const c of qs.categories) {
            const category = {
              id: c.id,
              title: c.title,
              description: c.description,
              sort: c.sort,
              questions: []
            };

            for (const q of c.questions) {
              const { id, text, type, multiple, sort } = q;
              const question = {
                id,
                text,
                type,
                multiple,
                sort,
                fields: [],
                answered: false
              };

              for (const f of q.fields) {
                const field = {
                  id: f.id,
                  label: f.label,
                  type: f.type,
                  note: f.note,
                  sort: f.sort,
                  level: f.level,
                  answer: answers[f.id],
                };

                if (typeof field.answer !== 'undefined') {
                  question.answered = true;
                }

                question.fields.push(field);
              }

              questionnaire.totalCount++;
              questionnaire.answeredCount += question.answered ? 1 : 0;
              question.fields.sort((a, b) => a.sort - b.sort);
              category.questions.push(question);
            }

            category.questions.sort((a, b) => a.sort - b.sort);
            questionnaire.categories.push(category);
          }

          questionnaire.categories.sort((a, b) => a.sort - b.sort);
          questionnaires.push(questionnaire);
        }

        return questionnaires;
      },
    },

    methods: {
      selectQuestionnaire(id) {
        this.questionnaireId = id;
      },

      async commentAnswer(id, comment) {
        const data = { id, comment, client: this.client.id };

        await this.$store.dispatch('ADD_QUESTIONNAIRE_COMMENT', data);
      },
    }
  };
</script>
